<template>
  <div class="row pb4 pt4 b--light-gray bb">
    <h5 class="title f-header black-40 mb2">{{ title }}</h5>
    <div class="flex items-stretch">
      <Prism
        language="html"
        class="w-40 pa5 br3 mr4 code items-center flex overflow-scroll"
        style="font-size: 1.3rem;"
      >{{ htmlTemplate }}</Prism>
      <div class="component flex items-center w-50 ml-auto">
        <component :is="showcaseComponent" v-bind="propsAndAttrs">
          <slot></slot>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import { computed } from '@vue/composition-api';

export default {
  name: 'Row',
  props: {
    title: {},
    showcaseComponent: {},
    props: {},
  },
  components: {
    Prism,
  },
  setup ({ props, showcaseComponent }, { attrs }) {
    const propsAndAttrs = computed(() => ({
      ...props,
      ...attrs,
    }));
    const htmlTemplate = computed(() => {
      const propsArray = Object.keys(propsAndAttrs.value || {}).reduce((acc, k) => {
        const value = propsAndAttrs.value[k];
        const isValueObject = value instanceof Object;
        const formattedValue = isValueObject ? JSON.stringify(value).replace(/"/g, '\'') : value;
        return [...acc, `${isValueObject ? ':' : ''}${k}="${formattedValue}"`].filter(val => !!val);
      }, []);
      const propsString = propsArray.length > 1 ? `\n\t${propsArray.join('\n\t')}\n` : propsArray.join('');
      return `<${showcaseComponent.name} ${propsString} />`;
    });
    return {
      htmlTemplate,
      propsAndAttrs,
    };
  },
};
</script>

<style lang="postcss" scoped>
.row {
  & .title {
    font-weight: 400;
  }
  & .component {
    flex-shrink: 0;
  }
}
</style>
